<template>
  <div class="table-header bg-grey fs-1-25r">
    <div
      v-for="(cell, i) of computedHeaders"
      :key="cell.title"
      :class="[
        'th fill-height px-2',
        cell.class,
        cell.sortable && 'pointer',
        i === 0 && 'first-cell',
        i === computedHeaders.length - 1 && 'last-cell',
        cell.value === 'details' && 'details-cell',
        cell.value === 'actions' && 'actions-cell',
        cell.value === 'name' && 'name-cell',
      ]"
    >
    <span>

        {{ cell.text }}
    </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableHeader',
  props: { user: Object, parent: String },
  computed: {
    computedHeaders() {
      const arr = 
      [
        {
          text: 'Group Name',
          value: 'name',
          align: 'left',
          width: 'fit-content',
          sortable: false,
        },
        {
          text: 'SFTP Access for Sending',
          value: 'details',
          align: 'left',
          width: 'fit-content',
          sortable: false,
        },
        {
          text: '',
          value: 'actions',
          align: 'center',
          width: 'fit-content',
        },
      ]
      console.log('parent', this.parent)
      console.log('user', this.user)
      if ( this.parent === 'admin' && this.user.license === 'SFTP'){
        return arr
      }
      else {
        return arr.filter((item) => item.value !== 'details')
      }
    },
  },
}
</script>

<style scoped src="@/design/TableHeader.css"></style>

<style scoped>
  .name-cell {
    flex-grow: 1;
  }
.details-cell {
  min-width: 200px;
  max-width: 200px;
  width: 200px;
}
.actions-cell {
  min-width: 90px;
  max-width: 90px;
  width: 90px;
}
</style>
